
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useQuestItemAdd } from '@/modules/quest/item/model/add';
import { QuestItemGameType } from '@/modules/quest/item/model/mixins';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, fetchQuestTypeOption, questTypeOptions, actions } = useQuestItemAdd();

        onMounted(async () => {
            await fetchQuestTypeOption();
        });

        return { v$, model, actions, questTypeOptions, QuestItemGameType };
    }
});
